import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";
import * as React from "react";

const inputVariant = cva("", {
    variants: {
        variant: {
            default:
                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary-dark disabled:cursor-text disabled:opacity-50 md:text-sm",
            ghost: "focus-visible:outline-none bg-transparent",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

const Input = React.forwardRef<
    HTMLInputElement,
    React.ComponentProps<"input"> & VariantProps<typeof inputVariant>
>(({ className, type, variant, ...props }, ref) => (
    <input
        ref={ref}
        className={cn(inputVariant({ variant, className }))}
        type={type}
        {...props}
    />
));
Input.displayName = "Input";

export { Input };
